import React from 'react';
import { Loader2Icon } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { WIZARD_STEP } from '@/entities/onboarding-status';

interface ResumeOnboardingChoiceProps {
	step: number;
	isLoading: boolean;
	onResume: () => void;
	onStartNew: () => void;
}

const STEP_LABELS: Record<number, string> = {
	[WIZARD_STEP.SMS_VERIFICATION]: 'la verificación de tu teléfono',
	[WIZARD_STEP.PAYMENT]: 'el pago',
	[WIZARD_STEP.KYC]: 'la verificación de tu identidad',
};

const ResumeOnboardingChoice: React.FC<ResumeOnboardingChoiceProps> = ({
	step,
	isLoading,
	onResume,
	onStartNew,
}) => (
	<div
		style={{
			display: 'flex',
			flexDirection: 'column',
			gap: 16,
			textAlign: 'center',
		}}
	>
		<h5>Tienes una solicitud de firma en curso</h5>
		<p>
			Quedaste en {STEP_LABELS[step] ?? 'un paso pendiente'}. Puedes
			continuarla donde la dejaste o iniciar una nueva solicitud.
		</p>
		<Button onClick={onResume} disabled={isLoading}>
			Continuar solicitud
		</Button>
		<Button variant="secondary" onClick={onStartNew} disabled={isLoading}>
			{isLoading && <Loader2Icon className="animate-spin" />}
			Iniciar una nueva
		</Button>
	</div>
);

export default ResumeOnboardingChoice;
